import { render, staticRenderFns } from "./TabbedView.vue?vue&type=template&id=6c7be4c1&"
import script from "./TabbedView.vue?vue&type=script&lang=js&"
export * from "./TabbedView.vue?vue&type=script&lang=js&"
import style0 from "./TabbedView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports